import React, { useEffect } from 'react';
import { useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useDispatch, } from "react-redux";
import customeStyle from './customeStyle';
import {
    uploadOneFile,
} from '../../../redux/upload/actions';
const EditorTiny = React.memo((props) => {

    const [value, setValue] = useState(props.data);
    const [text, setText] = useState('');
    const editorRef = useRef(props.data | null);
    const dispatch = useDispatch();

    const getdata = (editorRef) => {
        props.getData(editorRef.current.getContent())
    }
    const handleUploadImage = async (blobInfo, success, failure) => {
        console.log('call1231')
        let imageUpload = blobInfo.blob()
        let formData = new FormData();
        formData.append("file", imageUpload);
        console.log(blobInfo, blobInfo.blob(), 'test')
        let url = await dispatch(uploadOneFile(formData))
        return url;
    }

    useEffect(() => {
        setValue(props.data)
    }, [props])
    const linkScriptSrc = `${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`;
    return (
        <>
            <Editor
                tinymceScriptSrc={linkScriptSrc}
                onInit={(evt, editor) => {
                    editorRef.current = editor;
                    getdata(editorRef)
                }}
                initialValue={value}
                init={{
                    height: 500,
                    className: '1111111111111111',
                    plugins: 'save preview paste searchreplace autolink directionality visualblocks visualchars ' +
                        ' fullscreen template codesample table charmap hr pagebreak nonbreaking anchor toc ' +
                        'insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern media ' +
                        'help code image link font',
                    object_resizing: 'table, img, iframe, video, figure',
                    autosave_interval: '30s',
                    images_upload_url: 'postAcceptor.php',
                    image_advtab: true,
                    verify_html: true,
                    image_caption: true,
                    entity_encoding: "raw",
                    menubar: 'file edit view insert format tools table help font',
                    toolbar: "blocks | fontfamily | bold italic numlist bullist alignleft aligncenter alignright link pagebreak anchor save print codesample preview fullscreen | strikethrough hr fontsize lineheight forecolor backcolor outdent indent removeformat charmap emoticons undo redo help",
                    toolbar_mode: 'wrap',
                    font_size_formats: '8px 9px 10px 11px 12px 14px 16px 18px 20px 22px 24px 26px 28px 36px 48px 72px',
                    extended_valid_elements: 'img[style|class|src|alt|title|width|loading=lazy]',
                    imagetools_cors_hosts: ['picsum.photos'],
                    noneditable_noneditable_class: 'mceNonEditable',
                    table_border_styles: [{ title: 'White', value: 'FFFFFF' },],
                    content_style: customeStyle,
                    contextmenu: 'link image imagetools table font',
                    templates: [
                        { title: 'New Table', description: 'creates a new table', content: '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>' },
                        { title: 'Starting my story', description: 'A cure for writers block', content: 'Once upon a time...' },
                        { title: 'New list with dates', description: 'New List with dates', content: '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>' }
                    ],
                    setup: function (editor) {
                        editor.on('Change', (e) => getdata(editorRef))
                    },
                    images_upload_handler: handleUploadImage,
                }}
                scriptLoading={{ async: true }}
            />
            <input id="my-file" type="file" name="my-file" style={{ display: 'none' }} onChange="" />
        </>
    );
})
export default EditorTiny
